import { render, staticRenderFns } from "./SurveyLanguage.vue?vue&type=template&id=60c34d35&scoped=true&"
import script from "./SurveyLanguage.vue?vue&type=script&lang=js&"
export * from "./SurveyLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SurveyLanguage.vue?vue&type=style&index=0&id=60c34d35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c34d35",
  null
  
)

export default component.exports